import { combineReducers } from "redux";

const Index = (state = [], action) => {
  const { payload, toasts, intl } = action;
  switch (action.type) {
    case "SET_ALL_ROLES":
      return payload;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  Index,
});
